import { ConfigProvider } from "antd";
import AppRoutes from "./routes/appRoutes";
import antdCustomTheme from "./theme/antd.config";
import { QueryClientProvider } from "@tanstack/react-query";
import queryConfig from "./api/queryConfig";
import axios from "axios";
import { baseUrl } from "../config";
import { useAuth } from "./store";
import { useEffect } from "react";
import NetworkProtection from "./utils/networkProtection";
import ErrorBoundary from "./components/common/ErrorBoundary";
import NetworkStatus from "./components/common/NetworkStatus";

axios.defaults.baseURL = baseUrl + "/api";

function App() {
  const initializeAuth = useAuth((state) => state.initializeAuth);

  // Initialize authentication and network protection on app start
  useEffect(() => {
    initializeAuth();
    NetworkProtection.initializeProtection();
  }, [initializeAuth]);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryConfig}>
        <ConfigProvider theme={antdCustomTheme} componentSize="large">
          <NetworkStatus />
          <AppRoutes />
        </ConfigProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
